import Modal from "@/components/Common/Modal";
import {useCarouselStore} from "@/store/carousel";
import {useTranslation} from "react-i18next";

const IENotSupportedModal = () => {
  const {t} = useTranslation("common");
  const closeModal = useCarouselStore(state => () => state.setValue("isIENotSupportedModalOpen", false));

  return (
    <Modal
      onClose={closeModal}
      modalTitle={t("unsupportedBrowser")}
      customBottomRow={
        <button
          className="border-neutral-white-dark hover:bg-primary-light-solid m-4 h-16 flex-1 items-center justify-center self-end rounded-md border bg-white p-2 px-4 transition duration-500 hover:drop-shadow-md active:scale-95"
          type="button"
          onClick={closeModal}>
          <span className="text-primary-dark-solid text-base font-medium md:text-xl">{t("cancel")}</span>
        </button>
      }>
      <span>{t("internetExplorerIsNotSupported")}</span>
    </Modal>
  );
};

export default IENotSupportedModal;
